
document.addEventListener("DOMContentLoaded", function () {
    var deliveryContainer = document.querySelector(".delivery_zone__content");

    if (deliveryContainer) {
        var selectElement = deliveryContainer.querySelector("#delivery-zone");

        selectElement.addEventListener("change", function () {
            var selectedZone = this.value;

            // Masquer toutes les infos
            document.querySelectorAll(".delivery-info").forEach(function(el) {
                el.classList.remove("active");
            });

            // Afficher la bonne info
            document.getElementById("delivery-" + selectedZone).classList.add("active");
        });
    }
});